import React, { FunctionComponent, useState } from "react";
import { Box, Button, Paper, PaperProps, Toolbar } from "@mui/material";
import YouTube from "react-youtube";
import Draggable from "react-draggable";
import styles from "./styles.module.scss";
import NewWindow from "react-new-window";
import { PiperDialog } from "../PiperDialog";
import { Icon } from "../../icons/Icon";
import { IconType } from "../../icons/IconType";

function PaperComponent(props: PaperProps) {
  return (
    <Paper
      {...props}
      style={{ margin: 0, maxHeight: "100%", backgroundColor: "black", backgroundImage: "none" }}
    />
  );
}

export const YouTubePlayer: FunctionComponent<IYouTubePlayerProps> = ({
  title,
  videoIds,
  open,
  setOpen
}) => {
  const [inNewWindow, setInNewWindow] = useState(false);
  const opts = {
    height: "308",
    width: "526",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1 as const,
      playlist: videoIds?.join(",")
    }
  };
  const newWindowOpts = {
    height: "100%",
    width: "100%",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1 as const,
      playlist: videoIds?.join(",")
    }
  };
  return (
    <div>
      {inNewWindow ? (
        <div>
          {open && (
            <NewWindow
              copyStyles
              title={title}
              center={"parent"}
              onUnload={() => {
                setOpen(false);
                setInNewWindow(false);
              }}
            >
              <YouTube opts={newWindowOpts} />
            </NewWindow>
          )}
        </div>
      ) : (
        <Draggable>
          <PiperDialog
            open={open}
            hideBackdrop
            disableEnforceFocus
            disableScrollLock
            PaperComponent={PaperComponent}
            sx={{ width: "fit-content", height: "fit-content" }}
          >
            <Toolbar disableGutters className={styles.toolbar} style={{ cursor: "move" }}>
              <h4 className={styles.title}>{title}</h4>
              <Box flexGrow={1} />
              <Button
                onClick={() => {
                  setInNewWindow(true);
                }}
              >
                <Icon type={IconType.OpenInNew} />
              </Button>
              <Button
                onClick={() => {
                  setOpen(false);
                }}
              >
                <Icon type={IconType.Close} />
              </Button>
            </Toolbar>
            <YouTube className={styles.player} opts={opts} />
          </PiperDialog>
        </Draggable>
      )}
    </div>
  );
};

export interface IYouTubePlayerProps {
  title: string;
  videoIds?: string[];
  open: boolean;
  setOpen: (newValue: boolean) => void;
}
